/**
 * Created by WorkAxis www.workaxis.in
 * Navigation + footer shell.
 */
import React from 'react';
import "./style.css";
import {Link, NavLink} from "react-router-dom";

const navLinkClass = ({isActive}) => "wx-nav-link" + (isActive ? " is-active" : "");

const LOGO_SRC = "/images/workaxis-logo-dark.png";
const LOGO_FOOTER_SRC = "/images/workaxis-logo-white.png";

export default function NavigationFooter({children}) {
    const year = new Date().getFullYear();
    return (
        <div className="wx-page">
            <nav className="wx-nav">
                <div className="wx-nav-inner">
                    <Link to="/" className="wx-nav-brand">
                        <img src={LOGO_SRC} alt="WorkAxis" className="wx-brand-logo"/>
                    </Link>
                    <div className="wx-nav-links">
                        <NavLink to="/services" className={navLinkClass}>Services</NavLink>
                        <NavLink to="/products" className={navLinkClass}>Products</NavLink>
                        <NavLink to="/about" className={navLinkClass}>About</NavLink>
                    </div>
                    <Link to="/contact" className="wx-nav-cta">Discuss your project</Link>
                </div>
            </nav>

            {children}

            <footer className="wx-footer">
                <div className="wx-container">
                    <div className="wx-footer-inner">
                        <div className="wx-footer-brand">
                            <img src={LOGO_FOOTER_SRC} alt="WorkAxis" className="wx-brand-logo is-footer"/>
                        </div>
                        <div className="wx-footer-links">
                            <Link to="/services">Services</Link>
                            <Link to="/products">Products</Link>
                            <Link to="/about">About</Link>
                            <Link to="/contact">Contact</Link>
                            <a href="https://antcrm.co" target="_blank" rel="noreferrer">AntCRM</a>
                            <a href="mailto:hello@workaxis.in">hello@workaxis.in</a>
                        </div>
                        <div className="wx-footer-note">
                            WorkAxis © {year}
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}
